import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import {
  AccessControlOptionsType,
  AccessControlInterfaceType,
  RefreshType
} from './types';
import { IAccessControlService } from '../../../services/accessControlService';
import { Scope } from '../../../services/scope';

class AccessControlInterfaceV1 {
  private _accessControlService: IAccessControlService;

  constructor() {
    const services = getServices();
    this._accessControlService = services.accessControlService;
    bindAllMethods(this);
  }

  public getInterface(): AccessControlInterfaceType {
    return {
      refresh: this._refresh,
      checkScopes: this._checkScopes,
      check: this._check
    };
  }

  private async _refresh(
    refreshOptions?: RefreshType,
    options?: AccessControlOptionsType
  ): Promise<void> {
    return this._accessControlService.refresh(refreshOptions, options);
  }

  private async _checkScopes(
    scopesToCheck: Scope[],
    options: AccessControlOptionsType
  ): Promise<boolean> {
    return this._accessControlService.checkScopes(scopesToCheck, options);
  }

  private async _check(
    policies: string[],
    options: AccessControlOptionsType
  ): Promise<boolean> {
    return this._accessControlService.check(policies, options);
  }
}

export default AccessControlInterfaceV1;
